import { Card } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { GroupsList, GroupsListModal } from '@/components'
import { useGetGroupListQuery } from '@/generated/graphql'

import s from './user-manage.module.less'

interface FollowListGroupProps {
  userId: number
  type: 'myFollowing' | 'myCreated' | 'userFollowing' | 'userCreated'
  isMe: boolean
}

export const UserManageGroup: React.FC<FollowListGroupProps> = ({ userId, type, isMe }) => {
  const fetchCount = 8
  const { t } = useTranslation()

  const { data, error } = useGetGroupListQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    variables: {
      userId,
      ...(type === 'myFollowing' && { withViewer: true, withFollowing: true }),
      ...(type === 'myCreated' && { withViewer: true, withCreated: true }),
      ...(type === 'userFollowing' && { withUser: true, withFollowing: true }),
      ...(type === 'userCreated' && { withUser: true, withCreated: true }),
      filter: {},
      pagination: {
        last: 0,
      },
    },
  })

  if (error) {
    return null
  }

  const { totalCount, title } = (() => {
    switch (type) {
      case 'myFollowing':
        return { totalCount: data?.viewer!.followingGroups!.totalCount, title: t('personalMenu.followGroup') }
      case 'myCreated':
        return { totalCount: data?.viewer!.createdGroups!.totalCount, title: t('personalMenu.createdGroup') }
      case 'userCreated':
        return { totalCount: data?.user!.createdGroups!.totalCount, title: t('personalMenu.theirCreatedGroup') }
      case 'userFollowing':
        return { totalCount: data?.user!.followingGroups!.totalCount, title: t('personalMenu.theirfollowGroup') }
    }
  })()

  const onClickGroup = () => null

  const header = (
    <GroupsListModal
      onClickGroup={onClickGroup}
      showPin={isMe && true}
      showFollow={true}
      nameClickable={true}
      title={title}
      type={type}
      userId={userId}
    >
      <div className={s.cardTitle}>{title + ` · ${totalCount}`}</div>
    </GroupsListModal>
  )

  const list = (
    <GroupsList
      type={type}
      userId={userId}
      fetchCount={fetchCount}
      needStyle={false}
      showLoadmore={false}
      showSearch={false}
      showFollow={true}
      showPin={isMe && true}
      nameClickable={true}
      onClickGroup={onClickGroup}
      fetchPolicy='no-cache'
      nextFetchPolicy='no-cache'
    />
  )

  return <Card title={header}>{list}</Card>
}
